import * as THREE from 'three';
import ObjectsByName from '../../generic/container/ObjectsByName';
import PolyMesh from '../model/PolyMesh';
import PolyMap from '../model/PolyMap';
import removeUnusedValues from '../operator/removeUnusedValues';
import applyFunctionToPolyMap from './applyFunctionToPolyMap';

export default function removeInvalidSurfaces(polyMesh, withLogging) {

  //this algorithm assumes no duplicate indices
  //to remove those use removeDuplicateIndices first

  function removeInvalidSurfacesFromMap(polyMap, polyMapName, additionalArguments) {
    const l = additionalArguments.withLogging || false;

    const faceRangeOffsets = new Uint32Array(polyMap.faceRangeOffsets);
    const faceValueIndices = new Uint32Array(polyMap.faceValueIndices);
    const values = polyMap.values;

    let currentFaceIndex = 0;
    let previousFaceIndex = 0;
    let size = 0;

    let newFacesMarker = 1;
    let newIndicesMarker = 0;

    for (let i = 1; i < faceRangeOffsets.length; i++) {

      currentFaceIndex = faceRangeOffsets[i];
      size = currentFaceIndex - previousFaceIndex;

      if (size > 2) {
        //store face
        faceRangeOffsets[newFacesMarker] = faceRangeOffsets[newFacesMarker - 1] + size;
        newFacesMarker++;

        //store all the indices on that face
        for (let j = 0; j < size; j++) {
          faceValueIndices[newIndicesMarker++] = faceValueIndices[previousFaceIndex + j];
        }
      } else if (l) {
        console.log('Removed face ' + i + ' of size ' + size);
      }

      previousFaceIndex = currentFaceIndex;
    }

    const newFaceRangeOffsets = new Uint32Array(faceRangeOffsets.subarray(0, newFacesMarker));
    const newFaceValueIndices = new Uint32Array(faceValueIndices.subarray(0, newIndicesMarker));

    let resultMap = new PolyMap({
      faceRangeOffsets: newFaceRangeOffsets,
      faceValueIndices: newFaceValueIndices,
      values: values,
    });
    return resultMap;
  }

  const args = { withLogging };
  const resultMesh = applyFunctionToPolyMap(polyMesh, removeInvalidSurfacesFromMap, args);

  if (withLogging) console.log('' + (polyMesh.faceRangeOffsets.length - 1) + ' faces reduced to ' + (resultMesh.faceRangeOffsets.length - 1) + ', faces removed: ' + (polyMesh.faceRangeOffsets.length - resultMesh.faceRangeOffsets.length));

  return removeUnusedValues(resultMesh).topologyChanged();
}



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/removeInvalidSurfaces.js